import React from 'react'

const Product = ({costoFinale, nome, img , prezzo, children}) => { 
 
  const handleClick = () =>{
    console.log('mi hai premuto');
  }

  const paramsHandler = (prezzo)=>{
    console.log(prezzo);
    
  }

  const eventHandler = (price) => (e) => {
    console.log(e.target.innerText);
    console.log(price);
    
  }

  function prezzoPieno(price){
    return function prova(e){
      console.log(e.target.innerText);
    console.log(price);

    }
  }

  return (
    <article>
      {/* <article onMouseOver={ () => console.log(costoFinale) }></article> */}
      <div className='card'>
        <img src={img}  alt={`${nome}`} onClick={handleClick}/>
        <h6>{nome}</h6>   
        <hr/>
          <p>{prezzo}</p>   
          <p>bamby000</p>       
      </div>    
      <p className='card-time'>{children}</p>  
          <button onClick={() => alert(`nome : ${nome}`)}>
            {/* <button onClick={() => alert('bottone premuto')}></button> */}
            {costoFinale}€
          </button>  

           {/* <button onClick={() => alert(`nome : ${nome}`)}> args</button>  */}
            {/* <button onClick={() => paramsHandler(prezzo)}> args</button>  */}
            {/* <button onClick={eventHandler(prezzo)}> args</button>  */}
             <button onClick={prezzoPieno(prezzo)}> args</button> 
    </article>
  );
};

export default Product

